<template>
  <div class="train-login">
    <template v-if="isPopup">
      <van-popup
        v-model="show"
        position="right"
        close-on-popstate
        :get-container="getContainer"
        class="full-height full-width bg-lightGray"
      >
        <login12306-content
          :train-account.sync="trainAccount"
          :password.sync="password"
          :read.sync="read"
          :down="down"
          :account-list="accountList"
          :cxr-account-list="cxrAccountList"
          :tr-search-info="trSearchInfo"
          :agreement="Agreement"
          :travel-verificate-type="TravelVerificateType"
          @click-left="show = false"
          @face-detection="$refs['face-detection'].toggle()"
          @login="login"
          @check-account="checkAccount"
          @account-del="accountDel"
          @show-agreement="showAgreement = true"
          @show-register="showRegister = true"
        />
      </van-popup>
    </template>
    <template v-else>
      <login12306-content
        :train-account.sync="trainAccount"
        :password.sync="password"
        :read.sync="read"
        :down="down"
        :account-list="accountList"
        :cxr-account-list="cxrAccountList"
        :tr-search-info="trSearchInfo"
        :agreement="Agreement"
        :travel-verificate-type="TravelVerificateType"
        @click-left="show = false; $router.back()"
        @face-detection="$refs['face-detection'].toggle()"
        @login="login"
        @check-account="checkAccount"
        @account-del="accountDel"
        @show-agreement="showAgreement = true"
        @show-register="showRegister = true"
      />
    </template>


    <van-popup
      v-model="showAgreement"
      position="bottom"
      lock-scroll
      close-on-popstate
      class="full-width full-height"
      :get-container="getContainer"
    >
      <ld-header
        :title="Agreement.title"
        @click-left="showAgreement = false"
      />

      <pre
        class="pad8 pre-wrap"
        style="line-height: 20px;font-family: auto;"
      >
火车票12306购票服务协议
在使用火车票代订服务之前，请您（即用户）仔细阅读下述协议条款。一旦您点击确认本协议，即表示您已接受了以下所述的条款和条件，同意受本协议约束。如果您不同意接受全部的条款和条件，那么您将无法使用本协议约定的技术服务。
第一条 服务说明
1. 1通过{{ loginConfig.pageName }}预订火车票时，可自由选择自行通过您自有的12306账户和密码登陆12306进行预订，也可选择将您的12306账户和密码授权给{{ loginConfig.pageName }}进行代订。
1. 2为了更好地给您提供火车票代订服务，一旦您选择12306购票服务，您同意将您的12306账户和密码授权给{{ loginConfig.pageName }}，允许{{ loginConfig.pageName }}使用您的12306账户和密码登陆，并完成火车票预订及其相关退改签等操作。
1. 3 接受此协议，代表自愿委托使用我的12306乘客进行购票。
第二条 各方权利和义务
2. 1 {{ loginConfig.pageName }}提供的是火车票代订服务，您接受本协议，意味着您同意我们使用您填写的乘客信息进行代订，同时您须遵守12306的购票规定的服务条款（https: //kyfw. 12306.cn/otn/regist/rule) .
2. 2用户了解并同意，{{ loginConfig.pageName }}会根据您的授权使用您的12306账户及密码操作代订事宜，为了后续进一步向您提供服务，也会在系统中记录您的前述相关信息。但是对于您的隐私信息及相关交易信息，{{ loginConfig.pageName }}会严格保护。
2. 3 {{ loginConfig.pageName }}可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议。
2. 4本协议下的技术服务暂不向用户收取技术服务费，但{{ loginConfig.pageName }}保留收费的权利。
      </pre>
    </van-popup>

    <van-popup
      v-model="showRegister"
      position="bottom"
      lock-scroll
      close-on-popstate
      class="full-height full-width bg-lightGray"
      :get-container="getContainer"
    >
      <ld-header
        title="12306注册"
        @click-left="showRegister = false"
      />

      <van-cell-group class="register-wrap">
        <van-field
          v-model="register.userName"
          label="用户名"
          placeholder="请输入用户名"
          clearable
        />
        <van-field
          v-model="register.password"
          label="密码"
          type="password"
          placeholder="6-20位字母，数字或符号的组合"
          clearable
        />
        <van-field
          v-model="register.name"
          label="姓名"
          placeholder="请输入您真实姓名"
          clearable
        />
        <van-field
          v-model="register.idNo"
          label="身份证号码"
          placeholder="请输入身份证号码"
          clearable
        />
        <van-field
          v-model="register.mobileNo"
          label="手机号码"
          placeholder="请输入手机号"
          clearable
        />
      </van-cell-group>

      <div style="padding: 20px 8px">
        <ld-button
          main3
          size="lg"
          @click="handleRegister"
        >
          一键注册
        </ld-button>
      </div>

      <div
        class="font12 gray"
        style="
            position: fixed;
            bottom: 30px;
            padding: 8px;
        "
      >
        系统暂时只支持证件类型为身份证的用户注册，如需注册其他证件类型，可去12306官网进行注册或下载“铁路12306”APP注册。
      </div>
    </van-popup>

    <verificate
      ref="verificate"
      :element="element"
      :user-name="trainAccount"
      :password="password"
      :sms-check-msg="smsCheckMsg"
      @success="success"
    />

    <register-verificate
      ref="register-verificate"
      :element="element"
      :register="register"
      @success="registerSuccess"
    />

    <face-detection
      ref="face-detection"
      :element="element"
      :user-name="trainAccount"
      :password="password"
      @success="success"
    />
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 12306登录模块
 * @desc 12306登录信息源来自 tr/trSearchInfo.12306Info 中获取
 * @param {Object} trSearchInfo 查询信息对象
 * ————> @param {Object} _12306Info 存放12306的账号密码
 */
import { CellGroup, Cell, Popup, Field, RadioGroup, Radio, Checkbox, NoticeBar } from 'vant'
import { mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import verificate from './verificate12306.vue'
import registerVerificate from './register_verificate12306.vue'
import faceDetection from './face_detection12306.vue'
import { TravelVerificateType } from '@/business/Domain/use-cases/train-book-interactor'
import login12306Content from './components/login12306Content.vue'

const initialRegister = () => {
  return {
    userName: '',
    password: '',
    name: '',
    idNo: '',
    mobileNo: '',
    isMobileCheck: '',
    mobileSendCode: '',
    message: ''
  }
}

export default {
  components: {
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [NoticeBar.name]: NoticeBar,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton,
    verificate,
    registerVerificate,
    faceDetection,
    login12306Content
  },
  props: {
    element:{
      type: String,
      default: ''
    },
    isPopup: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      down:{ use: false },
      TravelVerificateType,
      show: false,
      showRegister: false,
      callback: '', // 登录成功后的回调
      trainAccount: '',
      password: '',
      read: true,
      showAgreement: false,
      smsCheckMsg: '', // 12306会返回该账号绑定的手机号的提示：请用尾号8610手机号码发短信666到12306
      Agreement: { title: '账户授权协议' },
      accountList: [],
      cxrAccountList: [],
      register: initialRegister()
    }
  },
  async created () {
    console.log('router', this.$route, this.$router)
    this.trainAccount = this.trSearchInfo['12306Info'].trainAccount
    this.password = this.trSearchInfo['12306Info'].password
    this.get12306Account()
  },
  methods: {
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    open (callback) {
      this.show = true
      this.callback = callback
      this.getCxrAccountList()
    },
    async get12306Account () {
      const { data = {} } = await this.$api['trQuery/12306TravelList']()
      this.accountList = data.accountList || []

      if (!this.trainAccount && this.accountList[0]) {
        this.checkAccount(this.accountList[0])
      }
    },
    async getCxrAccountList () {
      let cxrList = []
      cxrList = this.travelerList.map(psg => {
        return {
          name: this.$options.filters.getName(psg),
          idCardNo: psg.identy ? psg.identy : this.$options.filters.getIdNumber(psg),
        }
      })

      if (cxrList.length === 0) return

      const { data = [] } = await this.$api['trQuery/findCxrList']({ cxrList })
      this.cxrAccountList = data

      this.cxrAccountList.forEach((val) => {
        val.currentTrainAccount = val.userName
        val.currentPassword = val.userPassword
      })
    },
    checkAccount (account) {
      this.trainAccount = account.currentTrainAccount
      this.password = account.currentPassword
    },
    async accountDel (accountId) {
      this.$dialog.confirm({ title: '温馨提示', message: '您确定要删除该账号吗？' }).then(async () => {
        await this.$api['trQuery/12306AccountDel']({ accountId })

        this.get12306Account()
      })
    },
    async handleRegister () {
      try {
        if (!this.register.userName || !this.register.password || !this.register.name || !this.register.idNo || !this.register.mobileNo) {
          this.$toast('请完善注册信息')
          return
        }

        const { data = {} } = await this.$api['trQuery/registerAccount'](this.register)

        this.register.isMobileCheck = data.isMobileCheck
        this.register.mobileSendCode = data.mobileSendCode
        this.register.message = data.message

        if (data.isPass == 0) {
          this.$refs['register-verificate'].toggle()
        }

      } catch (error) {
        throw error
      }
    },
    login(autoLogin) {
      if (!autoLogin && !this.read) {
        this.$toast(`请先阅读并同意《${this.Agreement.title}》`)
        return
      }

      if (!this.trainAccount || !this.password) {
        this.$toast('请输入正确的账号和密码')
        return
      }

      let params = {
        password: this.password,
        userName: this.trainAccount,
        cxrList: this.travelerList.map(psg => {
          if (this.$options.filters.getIdNumber2(psg)) {
            return {
              passengerName: this.$options.filters.getName(psg),
              fsEmpId: psg.fsEmpId,
              empId: this.$options.filters.getId(psg),
              idType: this.$options.filters.getIdType(psg),
              idCode: this.$options.filters.getIdNumber2(psg),
              phoneNumber: psg.phoneNumber,
            }
          }
        })
      }

      this.$api['trQuery/12306Login'](params).then(res => {
        if (res.data == 0) {
          this.$dialog({
            message: '登陆失败！请核实后重新登录！'
          })
        } else if (res.data == 1) {
          this.success()
        } else {
          this.$dialog({
            message: '登录失败！请核实后重新登录！'
          })
        }
      }).catch(err => {
        if (err.errCode == '239001' || err.errCode == '239003') {
          this.$toast.clear()

          this.smsCheckMsg = err.tips
          this.$dialog.alert({
            title: '温馨提示',
            message: '根据铁路局规定，你的账号需要先完成短信核验。',
            confirmButtonText: '去核验',
          }).then(async () => {
            this.$refs['verificate'].toggle()
          })
        } else if (err.errCode == '239002') {
          this.$toast.clear()

          this.$refs['face-detection'].toggle()
        }
      })
    },
    registerSuccess () {
      this.showRegister = false

      this.trainAccount = this.register.userName
      this.password = this.register.password
      this.login()
      this.register = initialRegister()
    },
    // 登录成功
    success() {
      this.show = false
      this.trSearchInfo['12306Info'].trainAccount = this.trainAccount
      this.trSearchInfo['12306Info'].password = this.password
      this.callback && this.callback()

      //更新vux 中12306的登录信息
      this.$store.commit('tr/update12306Info', {
        trainAccount: this.trainAccount,
        password: this.password,
        isLoginSucccess: true,
      });

      this.get12306Account()
      this.$store.dispatch('tr/getAccountPsgList')
    },
  },
  computed: {
    ...mapState({
      loginConfig: state => state.app.loginConfig,
      trSearchInfo: state => state.tr.trSearchInfo,
      travelerList: state => state.tr.travelerList
    })
  }
}
</script>

<style lang="less">
.pad8 {
  padding: 8px;
}
.train-login-wrap {
  height: calc(100vh - 123px);
  overflow: hidden;
}

.login-12306-wrap {
  padding: 10px 8px;

  .mt10 {
    margin-top: 10px;
  }

  .tips-card {
    background-color: @color-background-lightYellow;
    border: 1px solid @color-text-main;
  }

  .van-cell__title {
    flex: auto;
  }
}

.register-card {
  width: calc(100% - 16px);
  margin: 0 8px;
  position: fixed;
  bottom: 8px;

  .cell-btn {
    width: auto;
    height: 32px;
    margin: 8px;
    margin-right: 0;
  }
}

.register-wrap {
  margin-top: 4px;
}

</style>
